import { makeImmutable } from "../core";
const LOCAL_STORAGE_CART_KEY = "client_cart";
const LOCAL_STORAGE_PREVIOUS_ORDER_CART_KEY = "client_previousOrder";
const CART_LIFETIME_S = 30 * 60 * 60; // 30 minutes
const PREVIOUS_ORDER_CART_LIFETIME_S = 3 * 60 * 60 * 60; // 3 hours
export class CartStorageManager {
    constructor() {
        makeImmutable(this);
    }
    get now() {
        return new Date().getTime();
    }
    clearCart() {
        localStorage.removeItem(LOCAL_STORAGE_CART_KEY);
    }
    storePreviousOrderCart() {
        const cartDataString = localStorage.getItem(LOCAL_STORAGE_CART_KEY);
        if (cartDataString !== null) {
            localStorage.setItem(LOCAL_STORAGE_PREVIOUS_ORDER_CART_KEY, cartDataString);
        }
    }
    restorePreviousOrderCart() {
        const prevCartDataString = localStorage.getItem(LOCAL_STORAGE_PREVIOUS_ORDER_CART_KEY);
        if (prevCartDataString === null) {
            return;
        }
        const cartData = JSON.parse(prevCartDataString);
        const { now } = this;
        const previousOrderAgeSeconds = (now - cartData.savedAt) / 1000;
        if (previousOrderAgeSeconds > PREVIOUS_ORDER_CART_LIFETIME_S) {
            return;
        }
        const cartDataString = JSON.stringify({
            savedAt: now,
            state: cartData.state,
        });
        localStorage.setItem(LOCAL_STORAGE_CART_KEY, cartDataString);
    }
    readCart() {
        const cartDataString = localStorage.getItem(LOCAL_STORAGE_CART_KEY);
        if (cartDataString === null) {
            // NOTICE No cart stored before
            return null;
        }
        const cartData = JSON.parse(cartDataString);
        const cartAgeSeconds = (this.now - cartData.savedAt) / 1000;
        if (cartAgeSeconds > CART_LIFETIME_S) {
            console.log(`Discarding stale cart, age=${cartAgeSeconds} seconds`);
            this.clearCart();
            return null;
        }
        console.log(`Cart loaded, age=${cartAgeSeconds} seconds`);
        return cartData.state;
    }
    writeCart(data) {
        const cartData = {
            savedAt: this.now,
            state: data,
        };
        const cartDataString = JSON.stringify(cartData);
        localStorage.setItem(LOCAL_STORAGE_CART_KEY, cartDataString);
    }
}
